export default {
  init($) {
    const storage = window.localStorage;
    const lang = 'LANG';

    const en = event => {
      event.preventDefault();
      event.stopPropagation();
      storage.setItem(lang, '#english');
      $('a.translator-language-en').trigger('click');
      $('.menu-item-has-children').html('<a href="#english">English</a><ul class="sub-menu"><li id="menu-item-1017" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1017"><a href="#spanish">Español</a></li></ul>');
      $('a[href=#spanish]').off().on('click', event => {
        sp(event);
      });
      $('a[href=#english]').off().on('click', event => {
        en(event);
      });
    };

    const sp = event => {
      event.preventDefault();
      event.stopPropagation();
      storage.setItem(lang, '#spanish');
      $('a.translator-language-es').trigger('click');
      $('.menu-item-has-children').html('<a href="#spanish">Español</a><ul class="sub-menu"><li id="menu-item-1017" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-1017"><a href="#english">English</a></li></ul>');
      $('a[href=#spanish]').off().on('click', event => {
        sp(event);
      });
      $('a[href=#english]').off().on('click', event => {
        en(event);
      });
    };

    $('a[href=#english]').on('click', event => {
      en(event);
    });
    $('a[href=#spanish]').on('click', event => {
      sp(event);
    });
  },
  finalize($) {
    const storage = window.localStorage;
    const lang = 'LANG';
    if(storage.getItem(lang) && ['#english', '#spanish'].includes(storage.getItem(lang))) {
      $('a[href='+storage.getItem(lang)+']').trigger('click');
    } else if(['#english', '#spanish'].includes(window.location.hash)) {
      $('a[href='+window.location.hash+']').trigger('click');
    }

  }
}
